<template>
  <div class="generic">
    <Headline>CSS Talks</Headline>

    <ContentBox headline="Panels">
      <ul class="arrow-style">
        <li v-for="panel in panelsList" :key="panel.name + panel.date">
          <b>{{ panel.name }}</b> ({{ panel.organizedBy }}).
          <span v-if="panel.type">{{ panel.type }} </span> <i>{{ panel.in }}</i
          >. {{ panel.institution }}, {{ panel.date }}.
        </li>
      </ul>
    </ContentBox>

    <ContentBox :headline="'Talks'">
      <h3
        class="eventlist-person-headline"
        v-if="getTalks('gramelsberger').length > 0"
      >
        Gabriele Gramelsberger
      </h3>
      <ul class="arrow-style" v-if="getTalks('gramelsberger').length > 0">
        <li
          class="eventlist-entry"
          v-for="talk in getTalks('gramelsberger')"
          :key="talk.name + talk.date"
        >
          <b>{{ talk.name }}</b
          >. {{ talk.type }} <i>{{ talk.in }}.</i> {{ talk.institution }},
          {{ talk.date }}.
        </li>
      </ul>
      <h3
        class="eventlist-person-headline"
        v-if="getTalks('kasprowicz').length > 0"
      >
        Dawid Kasprowicz
      </h3>
      <ul class="arrow-style" v-if="getTalks('kasprowicz').length > 0">
        <li
          class="eventlist-entry"
          v-for="talk in getTalks('kasprowicz')"
          :key="talk.name + talk.date"
        >
          <b>{{ talk.name }}</b
          >. {{ talk.type }} <i>{{ talk.in }}.</i> {{ talk.institution }},
          {{ talk.date }}.
        </li>
      </ul>
      <h3 class="eventlist-person-headline" v-if="getTalks('wenz').length > 0">
        Daniel Wenz
      </h3>
      <ul class="arrow-style" v-if="getTalks('wenz').length > 0">
        <li
          class="eventlist-entry"
          v-for="talk in getTalks(year, 'wenz')"
          :key="talk.name + talk.date"
        >
          <b>{{ talk.name }}</b
          >. {{ talk.type }} <i>{{ talk.in }}.</i> {{ talk.institution }},
          {{ talk.date }}.
        </li>
      </ul>
      <h3
        class="eventlist-person-headline"
        v-if="getTalks('kraemer').length > 0"
      >
        Carmen Krämer
      </h3>
      <ul class="arrow-style" v-if="getTalks('kraemer').length > 0">
        <li
          class="eventlist-entry"
          v-for="talk in getTalks('kraemer')"
          :key="talk.name + talk.date"
        >
          <b>{{ talk.name }}</b
          >. {{ talk.type }} <i>{{ talk.in }}.</i> {{ talk.institution }},
          {{ talk.date }}.
        </li>
      </ul>
      <h3
        class="eventlist-person-headline"
        v-if="getTalks('pantsar').length > 0"
      >
        Markus Pantsar
      </h3>
      <ul class="arrow-style" v-if="getTalks('pantsar').length > 0">
        <li
          class="eventlist-entry"
          v-for="talk in getTalks('pantsar')"
          :key="talk.name + talk.date"
        >
          <b>{{ talk.name }}</b
          >. {{ talk.type }} <i>{{ talk.in }}.</i> {{ talk.institution }},
          {{ talk.date }}.
        </li>
      </ul>
    </ContentBox>
  </div>
</template>

<script>
// TODO sort by date
import ContentBox from "@/components/ContentBox.vue";
import BlueBox from "@/components/BlueBox.vue";
import Headline from "@/components/Headline.vue";

export default {
  name: "TalksPage",
  props: {
    // will be set by router
    metaProp: Object,
  },
  // vue-head meta info
  metaInfo() {
    return this.metaProp;
  },
  components: {
    ContentBox,
    BlueBox,
    Headline,
  },
  computed: {
    talksList() {
      return this.$store.state.data.talks;
    },
    panelsList() {
      return this.$store.state.data.panels;
    },
  },
  methods: {
    getTalks(person) {
      return this.talksList.filter((entry) =>
        entry.by.toLowerCase().includes(person.toLowerCase()),
      );
    },
  },
  created() {
    this.$store.dispatch("fetchData", {
      url: "https://raw.githubusercontent.com/css-lab-rwth/csslab-web-content/master/data/events/talks.json",
      dir: "talks",
    });
    this.$store.dispatch("fetchData", {
      url: "https://raw.githubusercontent.com/css-lab-rwth/csslab-web-content/master/data/events/panels.json",
      dir: "panels",
    });
  },
};
</script>

<style scoped>
.generic {
  padding-bottom: 50px;
}
.eventlist-person-headline {
  color: rgb(0, 84, 159);
  font-weight: lighter;
  padding-bottom: 0px;
}
.eventlist-entry {
  padding-bottom: 0px;
  margin-bottom: -5px;
}
/* arrow-style globally defined in App.vue */
</style>
